import { render } from "./ProfileHeader.vue?vue&type=template&id=4b8a84ea"
import script from "./ProfileHeader.vue?vue&type=script&lang=ts"
export * from "./ProfileHeader.vue?vue&type=script&lang=ts"

import "./ProfileHeader.vue?vue&type=style&index=0&id=4b8a84ea&lang=scss"
script.render = render

export default script